import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/** One entry of a compile's reading line (#1818, design-1818 §3.6): the server's words for this reader, built at
 *  request time and never stored. A reader who cannot read the labels gets one entry with the sentence alone. */
export interface ReadingNoteEntry {
  decision?: string;
  state?: string;
  used_label?: string;
  others?: string[];
  sentence: string;
}

/** The Query Builder's and a dashboard tile's reading line (owner Q4): the sentence(s) only, no switch, no control. */
export default function ReadingNote({ readings, dense = false }: { readings?: ReadingNoteEntry[]; dense?: boolean }) {
  if (!readings || readings.length === 0) return null;
  return (
    <Box data-testid="reading-note" sx={{ mt: dense ? 0.25 : 1 }}>
      {readings.map((r, i) => (
        <Typography key={r.decision || `notice-${i}`} variant="caption" component="p"
                    sx={{ color: 'text.secondary', fontSize: dense ? 11 : 12, lineHeight: 1.4, m: 0 }}>
          {r.sentence}
        </Typography>
      ))}
    </Box>
  );
}
